export * from './vitalMeasurement.service';
import { VitalMeasurementService } from './vitalMeasurement.service';
export const APIS = [VitalMeasurementService];
